var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2471 2C19.2919 2 19.3362 2.00416 19.3789 2.01172C19.3844 2.0127 19.39 2.01354 19.3955 2.01465C19.4089 2.01733 19.4215 2.02299 19.4346 2.02637C19.4678 2.03494 19.5012 2.04344 19.5332 2.05664C19.5842 2.07769 19.6321 2.10449 19.6768 2.13574C19.712 2.16046 19.7458 2.18824 19.7773 2.21973C19.8257 2.26812 19.8631 2.32321 19.8955 2.37988C19.911 2.40704 19.9273 2.43374 19.9395 2.46289C19.9469 2.48096 19.951 2.50007 19.957 2.51855C19.9809 2.59179 19.9971 2.6688 19.9971 2.75V8.25C19.9971 8.66421 19.6613 9 19.2471 9C18.833 8.99981 18.4971 8.6641 18.4971 8.25V4.56055L9.69434 13.3633C9.40144 13.6562 8.92668 13.6562 8.63379 13.3633C8.34107 13.0704 8.34097 12.5956 8.63379 12.3027L17.4365 3.5H13.7471C13.333 3.49981 12.9971 3.1641 12.9971 2.75C12.9971 2.3359 13.333 2.00019 13.7471 2H19.2471Z",
    fill: "#001E3F",
    fillOpacity: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.9167V17.4167C16.5 17.9029 16.3068 18.3692 15.963 18.713C15.6192 19.0568 15.1529 19.25 14.6667 19.25H4.58333C4.0971 19.25 3.63079 19.0568 3.28697 18.713C2.94315 18.3692 2.75 17.9029 2.75 17.4167V7.33333C2.75 6.8471 2.94315 6.38079 3.28697 6.03697C3.63079 5.69315 4.0971 5.5 4.58333 5.5H10.0833",
    stroke: "#001E3F",
    strokeOpacity: 0.45,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand-icon.f244c8d6e73bd3956b35df93139d35c6.svg";
export { ForwardRef as ReactComponent };